module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSpinner),
      expression: "loadingSpinner"
    }],
    staticClass: "content-wrapper",
    attrs: {
      "element-loading-text": "Подождите"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-top": "0px"
    }
  }, [_vm._v("Заявки")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-5px",
      "padding-left": "5px",
      "float": "left"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.reloadOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-loop",
      "size": "18"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "0 10px 0 7px",
      "display": "inline-block"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "height": "36px",
      "margin-bottom": "0px",
      "color": "#b7b7b7",
      "text-decoration2": "underline"
    },
    attrs: {
      "type": "dashed",
      "size2": "large"
    },
    on: {
      "click": _vm.showDeletedItemsChangeMode
    }
  }, [(_vm.showDeletedItemsMode == false) ? _c('span', [_vm._v("АРХИВ")]) : _c('span', [_vm._v("ВЕРНУТЬСЯ ИЗ АРХИВА")])])], 1)]), _vm._v(" "), (_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.tasks != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', [_vm._v("\n  Подождите, загружаются данные по заявкам\n")]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 750px)",
      "height": "100%",
      "padding-right": "0px",
      "float": "left"
    },
    style: (_vm.expandTable == true ? '' : '')
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "padding-top": "11px",
      "padding-bottom": "0px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Фильтр")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "12px",
      "display": "inline-block",
      "width": "235px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.filterValueOnChange
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0px",
      "display": "inline-block",
      "float2": "left",
      "width": "160px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatusValue),
      expression: "filterStatusValue"
    }],
    staticStyle: {
      "width": "100%",
      "padding-top": "2px",
      "margin-left": "3px",
      "height": "36px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите статус"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterValueOnChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("ВСЕ СТАТУСЫ")]), _vm._v(" "), _vm._l((_vm.serverData.appSettings.finix.finixOrdersStatuses), function(item, index) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float2": "right",
      "margin": "0 10px 0 7px",
      "display": "inline-block"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "height": "36px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "ghost",
      "size": "large",
      "disabled": (_vm.editingDataRow != null) && (_vm.editingDataRow.val.id == null)
    },
    on: {
      "click": _vm.newEditingDataRowOnClick
    }
  }, [_vm._v("+")])], 1), _vm._v(" "), (_vm.showDeletedItemsMode == true) ? _c('div', {
    staticStyle: {
      "font-size": "15px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n    АРХИВ ЗАЯВОК:\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "datalist"
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "padding-right": "16px",
      "padding-top": "0px",
      "border-spacing": "0px"
    }
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.options.tableColumns), function(column, keyColumn) {
    return _c('th', {
      key: keyColumn,
      staticStyle: {
        "padding": "0px 5px 5px 0px",
        "font-weight": "normal",
        "border-bottom": "1px solid #ccc"
      },
      attrs: {
        "width": column.width,
        "align": "left"
      }
    }, [_vm._v("\n          " + _vm._s(column.title) + "\n        ")])
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "normal",
      "border-bottom": "1px solid #ccc"
    },
    attrs: {
      "width": "15px",
      "align": "left"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "datalist-scroll"
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "padding-top": "0px",
      "border-spacing": "0px"
    }
  }, _vm._l((_vm.filteredRecords), function(itemData, keyData) {
    return _c('tr', {
      key: keyData,
      staticStyle: {
        "width": "100%",
        "height": "32px"
      },
      style: ({
        background: _vm.isRowSelected(itemData) ? 'rgb(108,118,175)' : '#fff',
        color: _vm.isRowSelected(itemData) ? 'rgb(240,240,240)' : '#778087'
      }),
      on: {
        "click": function($event) {
          _vm.dataRowOnSelect(itemData)
        }
      }
    }, _vm._l((_vm.options.tableColumns), function(column, keyColumn) {
      return _c('td', {
        key: keyColumn,
        staticStyle: {
          "font-size": "12px",
          "padding": "2px 5px 2px 0px"
        },
        attrs: {
          "width": column.width,
          "align": "left"
        }
      }, [(column.field == 'status') ? _c('span', [_vm._v("\n              " + _vm._s(_vm.serverData.appSettings.finix.finixOrdersStatusesMap[itemData.val.body.status]) + "\n            ")]) : ((column.field == 'createdAt')) ? _c('span', [_vm._v("\n              " + _vm._s(_vm._f("formatDate")(itemData.val.createdAt)) + "\n            ")]) : ((column.field == 'client')) ? _c('span', [(_vm.serverData.partnersGetOneById(itemData.val.body.finix.client) != null) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.serverData.partnersGetOneById(itemData.val.body.finix.client).val.Name) + "\n              ")]) : _vm._e()]) : ((column.field == 'bank')) ? _c('span', [(_vm.serverData.finixBanksGetOneById(itemData.val.body.finix.bank) != null) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.serverData.finixBanksGetOneById(itemData.val.body.finix.bank).val.name) + "\n              ")]) : _vm._e()]) : ((column.field == 'saler')) ? _c('span', [(_vm.commonData.users[itemData.val.body.finix.saler] != null) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.commonData.users[itemData.val.body.finix.saler].Name) + "\n              ")]) : _vm._e()]) : ((column.field == 'manager')) ? _c('span', [(_vm.commonData.users[itemData.val.body.finix.manager] != null) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.commonData.users[itemData.val.body.finix.manager].Name) + "\n              ")]) : _vm._e()]) : _c('span', [_vm._v("\n              " + _vm._s(itemData.val[column.field]) + "\n            ")])])
    }))
  }))])])]), _vm._v(" "), _c('div', {
    class: (_vm.expandTable == true) ? 'hidden2' : '',
    staticStyle: {
      "width": "350px",
      "padding": "44px 0px 10px 20px",
      "border-left2": "1px solid #ccc",
      "float": "left",
      "min-height": "calc(100vh - 130px)"
    }
  }, [(_vm.editingDataRow != null) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "5px",
      "padding-bottom": "20px",
      "display": "inline-block",
      "float": "left"
    }
  }, [(_vm.editingDataRow.val.id != null) ? _c('span', [_c('b', [_vm._v("РЕДАКТИРОВАНИЕ :")])]) : _c('span', [_c('b', [_vm._v("НОВАЯ ЗАЯВКА :")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Название")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.name),
      callback: function($$v) {
        _vm.editingDataRow.val.name = $$v
      },
      expression: "editingDataRow.val.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Статус")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.status),
      expression: "editingDataRow.val.body.status"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите статус"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverData.appSettings.finix.finixOrdersStatuses), function(item, index) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Банк")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.bank),
      expression: "editingDataRow.val.body.finix.bank"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите банк"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.bank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverData.finixBanks), function(item, index) {
    return _c('option', {
      key: item.val.id,
      domProps: {
        "value": item.val.id
      }
    }, [_vm._v(_vm._s(item.val.name))])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Продавец")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.saler),
      expression: "editingDataRow.val.body.finix.saler"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px"
    },
    style: (((_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.ADMINS) && (_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.DIRECTORS)) ? 'background-color:#eee' : 'background-color:#fff'),
    attrs: {
      "filterable": "",
      "placeholder": "Выберите пользователя",
      "disabled": ((_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.ADMINS) && (_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.DIRECTORS)) ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.saler = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.commonData.users), function(item, index) {
    return ((item.GroupID <= _vm.serverData.appSettings.finix.userGroups.SALERS) && (item.Deleted == 0)) ? _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.Name))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Менеджер")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.manager),
      expression: "editingDataRow.val.body.finix.manager"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px"
    },
    style: (((_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.ADMINS) && (_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.DIRECTORS)) ? 'background-color:#eee' : 'background-color:#fff'),
    attrs: {
      "filterable": "",
      "placeholder": "Выберите пользователя",
      "disabled": ((_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.ADMINS) && (_vm.activeUser.GroupID != _vm.serverData.appSettings.finix.userGroups.DIRECTORS)) ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.manager = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.commonData.users), function(item, index) {
    return (item.GroupID == (_vm.serverData.appSettings.finix.userGroups.MANAGERS) && (item.Deleted == 0)) ? _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.Name))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Дата создания")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Выберите дату"
    },
    model: {
      value: (_vm.editingDataRow.val.createdAt),
      callback: function($$v) {
        _vm.editingDataRow.val.createdAt = $$v
      },
      expression: "editingDataRow.val.createdAt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Закон")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.zakon),
      expression: "editingDataRow.val.body.finix.zakon"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите банк"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.zakon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverData.appSettings.finix.finixOrdersZaroni), function(item, index) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(index))])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Вид заявки")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.zakon),
      expression: "editingDataRow.val.body.finix.zakon"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите банк"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.zakon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverData.appSettings.finix.finixOrdersVidi), function(item, index) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(index))])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Тип заявки")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.zakon),
      expression: "editingDataRow.val.body.finix.zakon"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите банк"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.zakon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverData.appSettings.finix.finixOrdersTipi), function(item, index) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(index))])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Ссылка на тендер")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.ssilka),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.ssilka = $$v
      },
      expression: "editingDataRow.val.body.finix.ssilka"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Сумма заявки")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.summa),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.summa = $$v
      },
      expression: "editingDataRow.val.body.finix.summa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Срок заявки")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left",
      "width": "110px"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Выберите дату"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.srokOt),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.srokOt = $$v
      },
      expression: "editingDataRow.val.body.finix.srokOt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 220px)"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Выберите дату"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.srokDo),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.srokDo = $$v
      },
      expression: "editingDataRow.val.body.finix.srokDo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Аванс (%)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.avancProcent),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.avancProcent = $$v
      },
      expression: "editingDataRow.val.body.finix.avancProcent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Аванс (руб)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "5px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.avancRub),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.avancRub = $$v
      },
      expression: "editingDataRow.val.body.finix.avancRub"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "0px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Бесспорное")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2px 0 5px 0",
      "padding-bottom": "0px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin": "0px 0 0 0"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.besspornoe),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.besspornoe = $$v
      },
      expression: "editingDataRow.val.body.finix.besspornoe"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "5px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Предмет контракта")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "5px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.predmet),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.predmet = $$v
      },
      expression: "editingDataRow.val.body.finix.predmet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "0px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Срочно")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2px 0 5px 0",
      "padding-bottom": "0px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin": "0px 0 0 0"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.srochno),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.srochno = $$v
      },
      expression: "editingDataRow.val.body.finix.srochno"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Площадка")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.body.finix.ploschadka),
      callback: function($$v) {
        _vm.editingDataRow.val.body.finix.ploschadka = $$v
      },
      expression: "editingDataRow.val.body.finix.ploschadka"
    }
  })], 1), _vm._v(" "), (_vm.editingDataRow.val.id != null) ? _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Номер")])]) : _vm._e(), _vm._v(" "), (_vm.editingDataRow.val.id != null) ? _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editingDataRow.val.id) + " \n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.saveEditingDataRowOnClick
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancelEditingDataRowOnClick
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('Button', {
    class: _vm.editingDataRow.val.id == null ? 'hidden' : '',
    staticStyle: {
      "float": "right",
      "border-radius": "3px",
      "margin-bottom": "10px",
      "padding-top": "5px",
      "color": "#d7d7d7"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.deleteEditingDataRowOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "trash-b",
      "size": "18"
    }
  }), _vm._v(" "), (_vm.editingDataRow.val.deleted == true) ? _c('Icon', {
    attrs: {
      "type": "ios-redo",
      "size": "18"
    }
  }) : _vm._e()], 1)], 1)]) : _c('div', [_c('br'), _c('br'), _c('br'), _vm._v("\n     * Выберите запись для просмотра или редактирования\n     "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    class: (_vm.expandTable == true) ? 'hidden2' : '',
    staticStyle: {
      "width": "350px",
      "margin-left": "10px",
      "padding": "44px 0px 10px 20px",
      "border-left2": "1px solid #ccc",
      "float": "left",
      "min-height": "calc(100vh - 130px)"
    }
  }, [(_vm.editingDataRow != null) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "5px",
      "padding-bottom": "20px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("КЛИЕНТ :")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Название")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.body.finix.client),
      expression: "editingDataRow.val.body.finix.client"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите клиента"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.body.finix.client = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverData.partners), function(item, index) {
    return ((item.val.ClientOrSupplier != 2) && (item.val.Deleted == 0)) ? _c('option', {
      key: item.id,
      domProps: {
        "value": item.val.id
      }
    }, [_vm._v(_vm._s(item.val.Name))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("ИНН")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.INN : '') + " \n          ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("ОГРНН")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.OGRNN : '') + " \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("КПП")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.KPP : '') + " \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Телефон")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.Phone : '') + " \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Email")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.Email : '') + " \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Контак.лицо")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.ContactName : '') + " \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Город")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.City : '') + " \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Адрес")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    attrs: {
      "v2-if2": "(editingDataRow.val.body.finix.client != '')"
    }
  }, [_vm._v("\n          " + _vm._s((_vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client) != null) ? _vm.serverData.partnersGetOneById(_vm.editingDataRow.val.body.finix.client).val.Address : '') + " \n        ")])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73304eb0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinixTasks/FinixTasks.vue
// module id = 403
// module chunks = 0